<div class="vm-resource">
  <div class="icon">
    <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" stroke-width="2" fill="none">
      <rect x="2" y="3" width="20" height="14" rx="2" />
      <path d="M16 21H8M12 17v4" />
      <path class="server-status" d="M6 7h.01M6 11h.01" />
    </svg>
  </div>
  <h2>Virtual Machine</h2>
  <div class="description">
    Create and configure virtual machines with customizable hardware and software configurations.
  </div>
</div>
